/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_No_Company_Assigned_TextInputs */

const en_company_no_company_assigned_text = /** @type {(inputs: Company_No_Company_Assigned_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account is not assigned to any company. Please contact your administrator.`)
};

const de_company_no_company_assigned_text = /** @type {(inputs: Company_No_Company_Assigned_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Account ist keinem Unternehmen zugewiesen. Bitte wenden Sie sich an den Administrator.`)
};

/**
* | output |
* | --- |
* | "Your account is not assigned to any company. Please contact your administrator." |
*
* @param {Company_No_Company_Assigned_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_no_company_assigned_text = /** @type {((inputs?: Company_No_Company_Assigned_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_No_Company_Assigned_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_no_company_assigned_text(inputs)
	return en_company_no_company_assigned_text(inputs)
});